var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import { AvtaleGiroPage } from './components/pages/AvtalegiroPage/AvtaleGiroPage';
import { DocumentSignedPage, DocumentSignedPageRedirect, } from './components/pages/DocumentSignedPage/DocumentSignedPage';
import { SigningPage } from './components/pages/SigningPage/SigningPage';
import { StartSavingPage } from './components/pages/StartSavingPage/StartSavingPage';
import { PersonvernInfoModal } from './components/common/PersonvernInfoModal/PersonvernInfoModal';
import { AboutForm } from './components/pages/FormPage/About/AboutForm';
import { AmountForm } from './components/pages/FormPage/Amount/AmountForm';
import { LoginPage } from './components/pages/LoginPage/LoginPage';
import { SpinnerPage } from './components/common/SpinnerPage/SpinnerPage';
import { FormStateProvider, useFormContext, useFormState } from './context/FormContext';
import { FEATURE_FLAG_ENDPOINT, getLoggedInCustomerData } from './utils/api';
import { KontoForm } from './components/pages/FormPage/Kontoopplysninger/KontoForm';
import { Action, RoutePath, FEATURE_FLAG_APP, defaultFeatureFlags } from './utils/types';
import { EgnethetForm } from './components/pages/FormPage/Raadgivning/EgnethetForm';
import { AnbefaltProfil } from './components/pages/FormPage/Profil/AnbefaltProfil';
import { useGlobalDispatch } from './context/GlobalContext';
import { ProfilForm } from './components/pages/FormPage/Profil/ProfilForm';
import { FeatureFlagsContext } from './AppWrapper';
import { FeatureFlagsProvider } from '@gjensidige/gpf-react-components';
import { FatcaForm } from './components/pages/FormPage/Raadgivning/FatcaForm';
import { Summary } from './components/pages/FormPage/Summary/Summary';
export const App = () => {
    return (React.createElement(HashRouter, null,
        React.createElement(GlobalModals, null),
        React.createElement(FormRouter, null),
        React.createElement(Switch, null,
            React.createElement(Route, { path: "/signing/:requestId" },
                React.createElement(SigningPage, null)),
            React.createElement(Route, { exact: true, path: "/signed" },
                React.createElement(DocumentSignedPageRedirect, null)),
            React.createElement(Route, { path: "/signed/:requestId" },
                React.createElement(DocumentSignedPage, null)),
            React.createElement(Route, { path: "/start-sparing/:requestId" },
                React.createElement(StartSavingPage, null)),
            React.createElement(Route, { path: "/avtalegiro/:kid/:status" },
                React.createElement(AvtaleGiroPage, null)))));
};
const FormRouter = () => {
    return (React.createElement(FormStateProvider, null,
        React.createElement(FormRoutes, null)));
};
const FormRoutes = () => {
    const [{ customerData }, dispatch] = useFormContext();
    const globalDispatch = useGlobalDispatch();
    const [isFetchingCustomer, setIsFetchingCustomer] = useState(true);
    useEffect(() => {
        if (!customerData.ssn) {
            getLoggedInCustomerData().then((res) => {
                if (res.isOk()) {
                    const customerData = res.value;
                    dispatch({ type: Action.SUBMIT_CUSTOMER_DATA, customerData });
                    const name = customerData.firstName + ' ' + customerData.surname;
                    globalDispatch({ type: Action.SET_CUSTOMER_NAME, name });
                }
                // Ignore errors here, since they do not influence the end user
                setIsFetchingCustomer(false);
            });
        }
    }, [customerData.ssn, dispatch, globalDispatch]);
    if (isFetchingCustomer) {
        return React.createElement(SpinnerPage, null);
    }
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: [RoutePath.LOGIN, RoutePath.CONTENT] },
            React.createElement(LoginPage, null)),
        React.createElement(FeatureFlagsProvider, { featureFlagsApiUrl: FEATURE_FLAG_ENDPOINT, applicationCode: FEATURE_FLAG_APP, defaultValue: defaultFeatureFlags, context: FeatureFlagsContext },
            React.createElement(FeatureToggledRoutes, null))));
};
const FeatureToggledRoutes = () => {
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: RoutePath.KONTO },
            React.createElement(KontoForm, null)),
        React.createElement(ProtectedFormRoute, { path: RoutePath.AMOUNT },
            React.createElement(AmountForm, null)),
        React.createElement(ProtectedFormRoute, { path: RoutePath.RAADGIVNING_EGNETHET },
            React.createElement(EgnethetForm, null)),
        React.createElement(ProtectedFormRoute, { path: RoutePath.ANBEFALT_PROFIL },
            React.createElement(AnbefaltProfil, null)),
        React.createElement(ProtectedFormRoute, { path: RoutePath.PROFIL },
            React.createElement(ProfilForm, null)),
        React.createElement(ProtectedFormRoute, { path: RoutePath.RAADGIVNING_FATCA },
            React.createElement(FatcaForm, null)),
        React.createElement(ProtectedFormRoute, { path: RoutePath.ABOUT },
            React.createElement(AboutForm, null)),
        React.createElement(ProtectedFormRoute, { path: RoutePath.SUMMARY },
            React.createElement(Summary, null))));
};
const GlobalModals = () => {
    return React.createElement(PersonvernInfoModal, null);
};
const ProtectedFormRoute = (_a) => {
    var { children, path } = _a, rest = __rest(_a, ["children", "path"]);
    const state = useFormState();
    return (React.createElement(Route, Object.assign({}, rest, { render: () => {
            return isValidStep(path, state) ? children : React.createElement(Redirect, { to: RoutePath.LOGIN });
        } })));
};
const isValidStep = (path, state) => {
    switch (path) {
        case RoutePath.LOGIN || RoutePath.KONTO:
            return true;
        case RoutePath.AMOUNT:
            return state.kontoopplysninger.submitted;
        case RoutePath.RAADGIVNING_EGNETHET:
            return state.kontoopplysninger.submitted;
        case RoutePath.ANBEFALT_PROFIL:
        case RoutePath.PROFIL:
            return !!state.risikoanbefaling;
        case RoutePath.RAADGIVNING_FATCA:
            return true;
        case RoutePath.ABOUT:
            return !!state.raadgivningData.fatca;
        case RoutePath.SUMMARY:
            return true;
        default:
            return false;
    }
};
